import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';


@Component({
    selector: 'app-form-throbber-button',
    templateUrl: './form-throbber-button.component.html',
    styleUrls: ['./form-throbber-button.component.scss'],
    standalone: true,
    imports: []
})
export class FormThrobberButtonComponent {
  @Input() throbbingFlag: boolean;
  @Input() buttonText: string;
  @Input() throbbingButtonText: string;
  @Input() buttonClass: string = 'btn-default';
  @Input() enabled: boolean;
  @Input() form: UntypedFormGroup;
  @Output() SubmitFormEvent: EventEmitter<any> = new EventEmitter();
  constructor() { }

  public submitForm(form: UntypedFormGroup) {
    if (form === undefined || form.valid) {
      this.SubmitFormEvent.emit();
    } else {
      this.markAsDirty(form);
    }
  }

  private markAsDirty(group: UntypedFormGroup | UntypedFormArray) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls.hasOwnProperty(i)) {
        if (group.controls[i] instanceof UntypedFormControl) {
          group.controls[i].markAsDirty();
          group.controls[i].markAsTouched();
        } else {
          this.markAsDirty(group.controls[i]);
        }
      }
    }
  }

}

/****
 * Usage:
 *
 * In a form
 *
 * <form [formGroup]="model.portfolioForm" (ngSubmit)="onSubmit(model.portfolioForm)">
 *     Form Controls...
 * <app-form-throbber-button
 * [inProgressFlag]="model.isUpdating"
 * [inProgressButtonText]="'Updating'"
 * [buttonText]="'Update'"
 * [buttonClass]="'btn-primary'"
 * [active]="model.canEdit"
 * </app-form-throbber-button>
 * </form>
 *
 *
 * Outside a form or general button with async call:
 *
 * <form [formGroup]="model.portfolioForm" (ngSubmit)="onSubmit(model.portfolioForm)">
 *     Form Controls...
 * </form>
 * <app-form-throbber-button
 * [inProgressFlag]="model.isUpdating"
 * [inProgressButtonText]="'Updating'"
 * [buttonText]="'Update'"
 * [buttonClass]="'btn-primary'"
 * [active]="model.canEdit"
 * (click)="onSubmit(model.portfolioForm)"> <--this can bind to any function for the parent component
 * </app-form-throbber-button>
 */
